import { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom';
import $ from 'jquery'

import { PortfolioUrl } from '../../obj/history';

import useAuthentication from '../../hooks/useAuthentication';
import useUserManagement from '../../hooks/useUserManagement'
import useProjectList from '../../hooks/useProjectList'

String.prototype.startsWithAny = function(array) {
    return array.some(item => this.startsWith(item))
}

const TopHeader = () => {
    const pscState = useSelector(state => state.pscState.value)
    const project = pscState.project
    const isLoading = pscState.isLoading

    const { currentUser } = useAuthentication();
    
    const {
        userHasProjectAccess,
        userHasProjectInformationAccess,
        userProjectIsFavourite,
        userAddFavouriteProject,
        userRemoveFavouriteProject,
        userShowNavigation
    } = useUserManagement()
    
    const [copied, setCopied] = useState(false)
    const [navigationCollapsed, setNavigationCollapsed] = useState(false)
    const [searchTerm, setSearchTerm] = useState('')
    const [portfolioSearchResults, setPortfolioSearchResults] = useState([])
    const [qualitySearchResults, setQualitySearchResults] = useState([])
    const [renderSearchResults, setRenderSearchResults] = useState(false)

    const location = useLocation()
        
    const searchresultsRef = useRef(null)

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside)
    }, [])
    
    const handleClickOutside = (event) => {
        if (searchresultsRef && searchresultsRef.current && !searchresultsRef.current.contains(event.target)) {
            handleClearSearch()
        }
    }

    const toggleNavigation = (e) => {
        e.preventDefault();
        $('body').toggleClass('mini-navbar'); // TODO remove jquery

        const hidden = $('#side-menu a:first').attr('data-tooltip-hidden')
        $('#side-menu a').attr('data-tooltip-hidden', hidden && hidden === 'true' ? 'false' : 'true')
        setNavigationCollapsed( !navigationCollapsed )
    }

    const nonProjectHeader = () => {
        const pathname = location.pathname
        if (pathname.startsWith('/cadm')) {
            return (
                <Link to="/cadm"
                    data-tooltip-id="gnctooltip" data-tooltip-content="Go back to CADM Admin menu">
                    Admin: Configuration and Document Management
                </Link>
            )
        }
        if (pathname.startsWithAny(['/security', '/users'])) {
            return (
                <Link to="/users"
                    data-tooltip-id="gnctooltip" data-tooltip-content="Go back to User Admin">
                    Admin: Users
                </Link>
            )
        }
        if (pathname.startsWith('/usergroups')) {
            return 'Admin: User Groups'
        }
        if (pathname.startsWithAny(['/serial_numbers', '/qa_documents', '/qms_documents', '/qa_records' ])) {
            return 'Quality'
        }
        if (pathname.startsWith('/account')) {
            return 'Account'
        }
        if (pathname.startsWith('/changelog')) {
            return 'Changelog'
        }
        if (pathname.startsWith('/main')) {
            return 'Home'
        }
        if (pathname.startsWith('/search')) {
            return 'Search'
        }
        if (pathname.startsWith('/portfolio/new')) {
            return (
                <Link to="/portfolio"
                    data-tooltip-id="gnctooltip" data-tooltip-content="Go back to Portfolio">
                    Portfolio
                </Link>
            )
        }
        if (pathname === '/portfolio') {
            return 'Portfolio'
        }
        return ''
    }

    const renderPageTitle = () => {
        let header = nonProjectHeader()
        if( header !== '' ) {
            return (
                <h1 className="topbar-title">
                    {header}
                </h1>
            )
        }
        
        // We're in a project
        let projectTitle = ''
        let projectName = '< No project selected >'
        let fav = ''
        let copyTitle = ''
        const archived = project && project.is_archived ?
            (
                <div key="archived-test" style={{color: 'rgba(103, 106, 108, 0.65)', fontSize: '13px'}}>
                    <i className="fa fa-archive" aria-hidden="true"></i> &nbsp;
                    <b>Archived.</b> This Portfolio item has been archived.
                </div>)
            : ''

        if( project && project.id && project.project_type &&
            ( userHasProjectAccess(currentUser, project.id) ||
              userHasProjectInformationAccess(currentUser, project.id, project.project_type.name) ) ) {
            
            projectTitle = project.project_code + ' ' + project.name
            projectName = (
                <Link to={`/portfolio/${project.id}/dashboard`} data-tooltip-id="gnctooltip" data-tooltip-content="Go to Dashboard">{project.project_type.name}: {projectTitle}</Link>
            )

            fav = userProjectIsFavourite(currentUser, project.id) ?
                (
                    <a to="#" onClick={() => { userRemoveFavouriteProject(currentUser, project.id) }}
                       className="set-favourite set-favourite-false"
                       data-tooltip-id="gnctooltip" data-tooltip-content="Unpin from Favourites">
                        <i className="fa fa-thumb-tack"></i>
                    </a>
                )
                :
                (
                    <a to="#" onClick={() => { userAddFavouriteProject(currentUser, project.id) }}
                       className="set-favourite set-favourite-true"
                       data-tooltip-id="gnctooltip" data-tooltip-content="Pin to Favourites">
                        <i className="fa fa-thumb-tack"></i>
                    </a>
                )
            
            copyTitle = (
                <a className="grey" style={{marginLeft: '12px', fontSize: '14px'}} onClick={() => onClick(projectTitle)}
                    data-tooltip-id="gnctooltip" data-tooltip-content="Copy Code and Name text to clipboard">
                    <i className="fa fa-clone"></i>
                </a>
            )
        }

        if( isLoading ) {
            projectName = 'Loading...'
            fav = ''
            copyTitle = ''
        }
        
        return (
            <h1 className="topbar-title">
                {projectName}
                &nbsp;
                <Link to={PortfolioUrl(location)} style={{fontSize: 14}}
                    data-tooltip-id="gnctooltip" data-tooltip-content="Go to Portfolio">
                    (Change)
                </Link>
                {fav}
                {copyTitle}
                {copied &&
                 <span style={{fontSize: '13px', marginLeft: '10px'}}>Copied!</span>
                }
                {archived}
            </h1>
        )
    }

    const copyToClipboard = (text) => {
        const textField = document.createElement('textarea')
        textField.innerText = text
        const parentElement = document.body
        parentElement.appendChild(textField)
        textField.select()
        document.execCommand('copy')
        parentElement.removeChild(textField)
    }

    const onClick = (text) => {
        copyToClipboard(text)
        setCopied(true)
        setTimeout(() => {
            setCopied(false)
        }, 750)
    }
    
    const handleClearSearch = () => {
        setSearchTerm('')
        setRenderSearchResults(false)
        setPortfolioSearchResults([])
        setQualitySearchResults([])
    }
    
    const search = (event) => {
        const searchTerm = event && event.target ? event.target.value : ''
        setSearchTerm(searchTerm)
        if( searchTerm.length < 3 ) {
            setRenderSearchResults(false)
            setPortfolioSearchResults([])
            setQualitySearchResults([])
            return
        }
        
        fetch(`/v0/cadm_search_all?query=${searchTerm}`, { credentials: 'same-origin' })
            .then(function(response) {
                return response.json()
            })
            .then(function(json) {
                setRenderSearchResults(true)
                if( json.result ) {
                    setPortfolioSearchResults(json.result.portfolio)
                    setQualitySearchResults(json.result.quality)
                    setTimeout(() => positionSearchBox(), 1)
                }
            })
    }

    const positionSearchBox = () => {
        var element = document.getElementById('sitewide-searchbox-wrapper')
        if( ! element ) {
            // stuff's not initialized yet
            return
        }
        
        var position = element.getBoundingClientRect()
        const top = position.top+40
        let left = position.left-500
        const width = position.width+280

        if( navigationCollapsed ) {
            left += 150
        }
        $('#sitewide-searchbox').css('top', top+'px')
        $('#sitewide-searchbox').css('left', left+'px')
        $('#sitewide-searchbox').css('width', width+'px')
    }
    
    const renderSearchBox = () => {
        const pathname = location.pathname
        if (pathname.startsWithAny(['/security', '/users', '/usergroups', '/cadm', '/search', '/account', '/changelog'])) {
            return false
        }

        positionSearchBox()
        return [(
            <div id="sitewide-search-link" key="sitewide-search-link">
                <Link to="/search" data-tooltip-id="gnctooltip" data-tooltip-content="Find Configured Items">
                    <i className="fa fa-search"></i>
                </Link>
            </div>
        ), (
            <div id="sitewide-searchbox-wrapper-wrapper" key="sitewide-searchbox-wrapper-wrapper">
                <div id="sitewide-searchbox-wrapper" ref={searchresultsRef}>
                    <span className="text-input-wrapper" key="wrapper">
                        <input
                            key="input"
                            className="input-sm form-control input-xs-sm inline sitewide-searchbox-input"
                            type="search"
                            id="searchbox"
                            placeholder="Find a configured item..."
                            value={searchTerm} onChange={search}
                        />
                    </span>
                    
                    {renderSearchResults &&
                     <div id="sitewide-searchbox" tabIndex="-1" role="dialog" aria-hidden="true">
                         {XXXrenderSearchResults()}
                     </div>
                    }
                </div>
            </div>
        )]
    }
    
    const XXXrenderSearchResults = () => {
        let output = []
        output.push(<h2 className="search-results">Portfolio</h2>)
        output.push(
            portfolioSearchResults.map(section => {
                return (
                    <div key={section.title}>
                        <h3 className="search-results"><i className={section.icon}></i> {section.title} ({section.results.length})</h3>
                        <ul className="search-results">
                            {section.results.map((item,index) => {
                                return (<li className="search-results" key={item.id}>
                                    <Link to={`/portfolio/${item.project_id}/${section.type}/${item.id}`}>
                                        {item.display_name}
                                    </Link><br/>
                                    <small className="search-results">{item.project_type}: {item.project_name} | Status: {item.object_status}</small>
                                </li>)
                            })}
                        </ul>
                    </div>
                )
            })
        )
        output.push(<h2 className="search-results">Quality</h2>)
        output.push(
            qualitySearchResults.map(section => {
                return (
                    <div key={section.title}>
                        <h3 className="search-results"><i className={section.icon}></i> {section.title} ({section.results.length})</h3>
                        <ul className="search-results">
                            {section.results.map((item,index) => {
                                 return (<li className="search-results" key={item.id}>
                                    <Link to={`/${section.type}/${item.id}`}>
                                        {item.display_name}
                                    </Link><br/>
                                    <small className="search-results">{section.title} | Status: {item.object_status}</small>
                                </li>)
                            })}
                        </ul>
                    </div>
                )
            })
        )
        return output
    }
    
    if (! userShowNavigation(currentUser)) {
        return <div/>
    }

    return (
        <div className="row">
            <nav className="navbar topbar" role="navigation">
                <a
                    href="#"
                    className="topbar-menu-btn btn btn-primary"
                    onClick={toggleNavigation}
                    data-tooltip-id="gnctooltip"
                    data-tooltip-content="Show Menu"
                >
                    <i className="fa fa-bars"></i>
                </a>

                {renderPageTitle()}

                {renderSearchBox()}

            </nav>
        </div>
    )
};

export default TopHeader
